module.exports = [{
      plugin: require('/home/circleci/jncampbell/wheresmyspaceship/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
